import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { Badge, Card } from '@pixlide/ui';

function CustomVideoIcon() {
  return (
    <svg
      width="40"
      height="37.5"
      viewBox="0 0 80 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M71.4803 51.61L8.68024 51.64C3.86024 51.64 0.000244141 47.94 0.000244141 43.12L0.0402527 8.10999C0.0402527 3.45999 4.09026 0 8.67026 0H71.2703C76.0803 0 79.9302 3.69999 79.9302 8.51999V43.13C79.9302 47.69 76.3502 51.6 71.4702 51.6L71.4803 51.61ZM71.4203 45.91C73.3103 45.71 74.1102 44.58 74.2802 43.04V8.60001C74.1102 6.97001 73.0303 5.73999 71.2603 5.73999H8.72025C7.01025 5.73999 5.71027 6.95001 5.71027 8.60001V43.04C5.71027 44.7 7.01025 45.9 8.72025 45.9H71.4302L71.4203 45.91Z"
        fill="currentColor"
      />
      <path
        d="M42.7203 68.89L2.85028 68.85C1.05028 68.85 -0.0197245 67.41 0.000275506 65.92C0.0202755 64.26 1.33029 63.1 3.23029 63.1L42.5403 63.12C43.3403 61.93 41.8003 57.78 45.4303 57.43C47.0103 57.28 48.5503 58.49 48.5403 60.33L48.5203 71.78C48.5203 73.41 47.1403 74.54 45.8003 74.58C44.1303 74.62 42.8403 73.39 42.8203 71.57C42.8203 70.75 42.9003 70.06 42.7103 68.89H42.7203Z"
        fill="currentColor"
      />
      <path
        d="M76.9503 68.85L57.2903 68.87C55.5003 68.87 54.2703 67.54 54.2803 65.94C54.3003 64.44 55.5503 63.11 57.3103 63.11L77.3703 63.17C78.9503 63.17 79.9003 64.7 79.9403 65.9C79.9903 67.44 78.9203 68.85 76.9503 68.85Z"
        fill="currentColor"
      />
      <path
        d="M51.7603 30.25L34.4903 40.93C32.8603 41.94 30.7803 41.76 28.9603 41C27.6603 40.45 25.7803 38.92 25.7803 36.86V14.77C25.7803 12.83 27.5003 11.34 28.6903 10.77C30.5303 9.89001 32.7803 9.66001 34.4803 10.71L51.7603 21.41C53.4003 22.42 54.2303 24.12 54.2303 25.82C54.2303 27.57 53.3903 29.23 51.7503 30.24L51.7603 30.25ZM47.9703 25.78L31.4603 15.59L31.5003 36.06L47.9803 25.78H47.9703Z"
        fill="currentColor"
      />
    </svg>
  );
}

function UpdateMenuIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 65.5675 65.5575"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M9.8375 1.7775C12.2075 -0.5925 16.0375 -0.5925 18.3975 1.7775L25.6675 9.04749C26.5975 9.97749 26.5975 11.4875 25.6675 12.4175C24.7375 13.3475 23.2275 13.3475 22.2975 12.4175L20.4275 10.5475L16.8575 14.1175C15.9275 15.0475 14.4175 15.0475 13.4875 14.1175C12.5575 13.1875 12.5575 11.6775 13.4875 10.7475L17.0575 7.17749L15.0375 5.15751C14.5375 4.65751 13.7175 4.65751 13.2175 5.15751L5.1475 13.2275C4.6475 13.7275 4.6475 14.5475 5.1475 15.0475L12.4175 22.3175C13.3475 23.2475 13.3475 24.7575 12.4175 25.6875C11.4875 26.6175 9.97752 26.6175 9.04752 25.6875L1.7775 18.4175C-0.5925 16.0475 -0.5925 12.2175 1.7775 9.85749L9.84751 1.78748L9.8375 1.7775Z"
        fill="currentColor"
      />
      <path
        d="M55.2075 38.5775C54.2775 37.6475 52.7675 37.6475 51.8375 38.5775C50.9075 39.5075 50.9075 41.0175 51.8375 41.9475L54.6975 44.8075L50.7975 48.7075C49.8675 49.6375 49.8675 51.1475 50.7975 52.0775C51.7275 53.0075 53.2375 53.0075 54.1675 52.0775L58.0675 48.1775L60.4175 50.5275C60.9175 51.0275 60.9175 51.8475 60.4175 52.3475L52.3475 60.4175C51.8475 60.9175 51.0275 60.9175 50.5275 60.4175L41.9475 51.8275C41.0175 50.8975 39.5075 50.8975 38.5775 51.8275C37.6475 52.7575 37.6475 54.2675 38.5775 55.1975L47.1675 63.7875C49.5375 66.1475 53.3675 66.1475 55.7275 63.7875L63.7975 55.7175C66.1575 53.3575 66.1575 49.5175 63.7975 47.1575L55.2075 38.5675V38.5775Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.1775 4.32749C54.8075 -1.04251 46.0975 -1.04251 40.7275 4.32749L5.90752 39.2075C5.06752 40.0475 4.4875 41.1275 4.2575 42.2975L0.467519 61.2275C0.307519 62.0075 0.557544 62.8175 1.11754 63.3775C1.67754 63.9375 2.48751 64.1875 3.26751 64.0275L22.2575 60.2375C23.4275 60.0075 24.5075 59.4275 25.3575 58.5775L60.1675 23.7675C65.5375 18.3975 65.5375 9.68751 60.1675 4.31751L60.1775 4.32749ZM14.6975 37.1475L38.9075 12.8875L51.6075 25.5875L27.3375 49.8575C27.0475 49.4675 26.7275 49.0775 26.3675 48.7175C24.4375 46.7875 21.9175 46.0075 20.0975 45.6675C19.7375 45.5975 19.3975 45.5475 19.0775 45.5075C19.0375 45.1575 18.9875 44.7875 18.9075 44.3975C18.5675 42.5775 17.7875 40.0575 15.8575 38.1275C15.4875 37.7575 15.0975 37.4375 14.6975 37.1475ZM54.9875 22.2175L42.2875 9.51749L44.1075 7.69748C47.6175 4.18748 53.2975 4.18748 56.8075 7.69748C60.3175 11.2075 60.3175 16.8875 56.8075 20.3975L54.9875 22.2175ZM11.2475 40.6075L9.28753 42.5675C9.10753 42.7475 8.98749 42.9775 8.93749 43.2275L5.84752 58.6575L21.3275 55.5675C21.5775 55.5175 21.8075 55.3975 21.9875 55.2175L23.8775 53.3275C23.6275 52.8675 23.3375 52.4475 22.9875 52.1075C22.0475 51.1675 20.6275 50.6375 19.2175 50.3775C18.5475 50.2575 17.9475 50.2075 17.5175 50.1875C17.3075 50.1875 17.1375 50.1775 17.0275 50.1875C16.9775 50.1875 16.9375 50.1875 16.9175 50.1875H16.8975C15.5875 50.2475 14.4675 49.2375 14.4075 47.9175C14.4075 47.8675 14.4075 47.8075 14.4075 47.7575C14.4075 47.7075 14.4075 47.6575 14.4075 47.6075V47.5875C14.4075 47.5875 14.4075 47.5275 14.4075 47.4775C14.4075 47.3675 14.4075 47.2075 14.4075 46.9875C14.3875 46.5575 14.3375 45.9575 14.2175 45.2875C13.9575 43.8875 13.4275 42.4675 12.4875 41.5175C12.1375 41.1675 11.7175 40.8675 11.2475 40.6175V40.6075Z"
        fill="currentColor"
      />
    </svg>
  );
}

function OptionCard({
  to,
  icon,
  title,
  description,
  badgeLabel,
}: {
  to: string;
  icon: ReactNode;
  title: string;
  description: string;
  badgeLabel: string;
}) {
  return (
    <Card raised className="relative flex flex-col gap-4 p-7 transition hover:-translate-y-0.5">
      <span aria-hidden className="text-ink-900">
        {icon}
      </span>

      <div>
        <h3 className="text-lg leading-snug font-semibold">{title}</h3>
        <p className="mt-2 text-sm text-ink-500">{description}</p>
      </div>

      <Badge tone="brand">
        <span className="tracking-wide uppercase">{badgeLabel}</span>
      </Badge>

      {/* Le lien couvre toute la carte : la zone cliquable correspond à la zone
          visuellement cliquable, et le libellé accessible reste le titre de la carte. */}
      <Link to={to} className="absolute inset-0 rounded-card" aria-label={title}>
        <span className="sr-only">{title}</span>
      </Link>
    </Card>
  );
}

/**
 * Choix du parcours de création : commande sur-mesure vs. mise à jour d'un menu existant.
 *
 * Reprend la maquette du board produit. Les deux options renvoient vers des parcours déjà
 * déclarés dans le routeur (`/creer/sur-mesure` pour la commande, `/creer/menu` pour l'édition
 * de menu) plutôt que d'imbriquer un choix supplémentaire ici.
 */
export function CreateVideoPage() {
  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-8">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Création personnalisée</h1>
        <p className="mt-1.5 text-ink-500">
          Vous pouvez commander votre template designé sur mesure pour une vidéo totalement à
          votre image.
        </p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2">
        <OptionCard
          to="/creer/sur-mesure"
          icon={<CustomVideoIcon />}
          title="Je commande ma propre vidéo / menu"
          description="Design exclusif réalisé par nos experts selon votre charte graphique."
          badgeLabel="Sous 48 h"
        />

        <OptionCard
          to="/creer/template"
          icon={<UpdateMenuIcon />}
          title="Utiliser mon menu et mettre à jour son contenu"
          description="Gérez vos changements de prix, nouveaux plats et promotions instantanément avec l'aide de l'IA."
          badgeLabel="Mise à jour immédiate"
        />
      </div>
    </div>
  );
}
